import {searchAutocomplete, searchQueryURL} from "../api/common";

export async function loadSearchAutocomplete(query) {
  const response = await fetch(searchAutocomplete(query)).then((res) =>
    res.json()
  );
  return response;
}

export function searchAutocompleteEntry(value, isCustomStore) {
  value = isCustomStore ? value.split('store')[1] : value
  if (value.length > 0) {
    window.location.assign(value);
  }
}

export function searchOnKeyDown(e, isCustomStore) {
  if (e.key === `Enter` && e.target.value.length > 0) {
    window.location.assign(searchQueryURL(e.target.value, isCustomStore));
  }
}
